import React, { useEffect } from "react";
import useModalStore from "../../zustandStores/useModalStore";
import PremiumPopup from "../PremiumPopup";
import ButtonGroup from "../ButtonGroup";
import UpgradeToPremiumView from "../UpgradeToPremiumView";
import { modalStateValues } from "../../services/constants";
import usePremiumJobCreditsBreakUp from "../../hooks/premiumJobCreditsBreakUp";
import useSingleJobSkus from "../../zustandStores/singleJobSkus";
import useMetaLabels from "../../hooks/metaLabels";
import { PerksDrawbackProps } from "components/JobType/v2/PerksDrawback";
import { getDataInMonthDateCommaYear } from "utils/creditUtils";
import { useModalCleanup } from "../../utils/modalUtils";

const UpgradeJob = (): JSX.Element => {
  const { modalData, setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));
  const { heading, state, callback, jobId, closeCallback, subHeading } =
    modalData;
  const { discountedCredits, isSpecialPrice } = usePremiumJobCreditsBreakUp({
    jobId
  });
  const { open } = modalStateValues;
  const isPopupOpen = state === open;
  const { cleanupOnClose } = useModalCleanup();
  
  const handleClose = () => {
    setModalData({
      ...modalData,
      type: "",
      state: modalStateValues.CLOSE
    });
    if (closeCallback) closeCallback();
  };
  
  const onClose = cleanupOnClose(handleClose);

  const { premiumSku } = useSingleJobSkus((state: any) => ({
    premiumSku: state.premiumSku
  }));
  const { cityId: metaCityId = null, categoryId: metaCategoryId = null } =
    premiumSku;
  const { cityLabel, categoryLabel } = useMetaLabels({
    cityId: metaCityId,
    categoryId: metaCategoryId
  });

  const popupHeading = heading
    ? heading
    : `Upgrade this job by using ${discountedCredits} credits.`;
  const defaultSubHeading = isSpecialPrice
    ? `${categoryLabel} jobs in ${cityLabel} are available at a special price.`
    : "";
  const popupSubHeading = subHeading ?? defaultSubHeading;
  const perksDrawbackList: PerksDrawbackProps = {
    list: [
      {
        type: "perk",
        value: "High number of direct applies"
      },
      {
        type: "perk",
        value: "High number of database matches"
      },
      {
        type: "perk",
        value: "Increased job reach"
      },
      {
        type: "perk",
        value: "Get noticed by an urgent hiring tag"
      },
      // {
      //   type: "perk",
      //   value: "Get one job boost for free - limited time offer"
      // },
      {
        type: "perk",
        value: `Job validity will be extended till ${getDataInMonthDateCommaYear()}.`
      }
    ]
  };
  return (
    <PremiumPopup
      heading={popupHeading}
      open={isPopupOpen}
      subHeading={popupSubHeading}
      onClose={onClose}
      jobId={jobId}
      perksDrawbackList={perksDrawbackList}
      renderButtons={() => {
        return (
          <ButtonGroup>
            <UpgradeToPremiumView
              className="w-full"
              jobId={jobId}
              callback={callback}
            >
              Upgrade this job
            </UpgradeToPremiumView>
          </ButtonGroup>
        );
      }}
    />
  );
};
export default UpgradeJob;
